module.exports = function() {
  return new Worker(__webpack_public_path__ + "031867f35e18422c7195.worker.js");
};